import { CashboxFilters, CashboxNewArticle } from '../types';

export const CASHBOX_INITIAL_NEW_ARTICLE_STATE: CashboxNewArticle = {
  executed: '',
  amount: '',
  income: '',
  expense: '',
  operation_type: undefined,
  article: undefined,
  comment: '',
  cashbox: undefined,
  counterparty: undefined,
};

export const DEFAULT_PAGE_SIZE = 25;
